export default __webpack_public_path__ + "static/media/rupeesBg.262a2b53.svg";